import * as React from "react";
const SvgSortDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, viewBox: "0 0 17 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#1C313A", fillRule: "evenodd", d: "M8.584 11l4.002-5H4.58z" }));
export default SvgSortDown;
